<template>
  <div>
    <div class="folder-card text-center" v-if="folders.length == 0">
      SEM RESULTADOS
    </div>
    <div class="folder-container" v-if="folders.length > 0">
      <div class="folders-grid">
        <div v-for="folder in folders" :key="folder.id" class="folder-card">
          <div class="card-header">
            <div class="card-icon">
              <i class="fas fa-folder"></i>
            </div>

            <div class="card-info">
              <h3 class="card-title">{{ folder.name }}</h3>

              <div class="card-meta">
                <span class="folder-type-badge">
                  <i class="fas fa-building mr-1"></i>
                  {{
                    folder.type_folder == "EMPRESA" ? "Empresa" : "Residente"
                  }}
                </span>

                <span
                  class="folder-visibility-badge"
                  :class="folder.public_folder == 1 ? 'public' : 'private'"
                >
                  <i
                    :class="
                      folder.public_folder == 1
                        ? 'fas fa-globe mr-1'
                        : 'fas fa-lock mr-1'
                    "
                  ></i>
                  {{ folder.public_folder == 1 ? "Pública" : "Privada" }}
                </span>
              </div>
            </div>
          </div>

          <div v-if="folder.resident_name" class="resident-info">
            <div class="info-header">
              <i class="fas fa-user-circle info-icon"></i>
              <span class="info-label">Residente</span>
            </div>
            <span class="resident-name">{{ folder.resident_name }}</span>
          </div>

          <div
            v-if="folder.linkedUsers && folder.linkedUsers.length"
            class="users-info"
          >
            <div class="info-header">
              <i class="fas fa-users info-icon"></i>
              <span class="info-label"
                >Usuários Vinculados ({{ folder.linkedUsers.length }})</span
              >
            </div>
            <div class="users-list">
              <div
                class="user-item"
                v-for="user in folder.linkedUsers"
                :key="user.id"
              >
                <i class="fas fa-user user-icon"></i>
                <span class="user-name">{{ user.name }}</span>
              </div>
            </div>
          </div>

          <div class="card-footer">
            <div class="action-buttons">
              <confirmation-dialog
                v-if="permission('remove', 'folder')"
                messageTitle="EXCLUIR"
                openText="EXCLUIR"
                message-body="Deseja realmente excluir essa Pasta?"
                open-class="btn-modern btn-modern-delete"
                open-left-icon="fa-trash"
                @yes="deleteFolder(folder.id)"
              />

              <v-btn
                v-if="permission('edit', 'folder')"
                class="btn-edit-modern"
                @click="handleUpdate(folder.id)"
              >
                <i class="fas fa-edit mr-1"></i>
                Editar
              </v-btn>

              <v-btn class="btn-access-modern" @click="goToFolder(folder.id)">
                <i class="fas fa-folder-open mr-2"></i>
                Abrir Pasta
              </v-btn>
            </div>
          </div>
        </div>
      </div>

      <UpdateFolder
        v-if="showUpdate"
        :folder_id="folder_id"
        @update="handleChange"
        @close="showUpdate = false"
      />
    </div>
  </div>
</template>

<script>
import api from "../../services/api";

import toast from "../../lib/ToastNotification";

import ConfirmationDialog from "../../templates/Components/ConfirmationDialog";

import UpdateFolder from "./UpdateFolder";

import permission from "../../lib/permission";

export default {
  name: "ListFolder",

  components: {
    ConfirmationDialog,
    UpdateFolder,
  },

  data() {
    return {
      folder_id: null,

      showUpdate: false,
    };
  },

  props: {
    folders: {
      type: Array,
      default: () => [],
    },
  },

  watch: {
    folders: {
      handler(folder) {
        if (!folder || !folder.length) {
          this.$emit("noResults");
        } else {
          this.$emit("hasResults");
        }
      },

      immediate: true,
    },
  },

  methods: {
    permission,

    async deleteFolder(folder_id) {
      try {
        this.loading = true;

        const id = folder_id;

        let params = { id };

        const response = await api.delete("/folder", { params });

        const { error, message } = response.data;

        if (!error) {
          toast(message, "success");

          this.errors = [];

          this.$emit("change");
        } else {
          toast(message, "error");
        }

        this.loading = false;
      } catch (error) {
        this.loading = false;

        console.log(error);
      }
    },

    handleUpdate(folder_id) {
      this.folder_id = folder_id;
      this.showUpdate = true;
      this.$nextTick(() => {
        this.$bvModal.show("updateFolder-" + folder_id);
      });
    },

    handleChange() {
      this.$emit("change");
    },

    goToFolder(folder_id) {
      this.$router.push(`/folder/docs/${folder_id}`);
    },
  },
};
</script>

<style scoped>
.folder-container {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 24px;
}

.folders-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(380px, 1fr));
  gap: 24px;
  margin: 32px 0;
}

/* Folder Card */
.folder-card {
  background: white;
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.2);
  display: flex;
  flex-direction: column;
  padding: 24px;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}

.folder-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 12px 32px rgba(15, 101, 176, 0.15);
  border-color: #0f65b0;
}

.folder-card::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(135deg, #0f65b0 0%, #1e40af 100%);
}

/* Card Header */
.card-header {
  display: flex;
  align-items: flex-start;
  gap: 16px;
  margin-bottom: 20px;
}

.card-icon {
  color: #0f65b0;
  font-size: 32px;
  flex-shrink: 0;
  padding: 12px;
  background: linear-gradient(135deg, #e0f2fe 0%, #b3e5fc 100%);
  border-radius: 12px;
  border: 1px solid #0891b2;
  transition: all 0.3s ease;
}

.folder-card:hover .card-icon {
  transform: scale(1.05);
  background: linear-gradient(135deg, #0f65b0 0%, #1e40af 100%);
  color: white;
}

.card-info {
  flex: 1;
  min-width: 0;
}

.card-title {
  font-size: 18px;
  font-weight: 600;
  color: #1e293b;
  margin: 0 0 12px 0;
  word-break: break-word;
  line-height: 1.4;
}

.card-meta {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

/* Badge Styles */
.folder-type-badge,
.folder-visibility-badge {
  display: inline-flex;
  align-items: center;
  padding: 4px 10px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  width: fit-content;
}

.folder-type-badge {
  background: linear-gradient(135deg, #e0e7ff 0%, #c7d2fe 100%);
  color: #4338ca;
  border: 1px solid #818cf8;
}

.folder-visibility-badge.public {
  background: linear-gradient(135deg, #d1fae5 0%, #a7f3d0 100%);
  color: #059669;
  border: 1px solid #34d399;
}

.folder-visibility-badge.private {
  background: linear-gradient(135deg, #fef3c7 0%, #fed7aa 100%);
  color: #d97706;
  border: 1px solid #f59e0b;
}

/* Info Sections */
.resident-info,
.users-info {
  margin: 16px 0;
  padding: 16px;
  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
  border-radius: 12px;
  border: 1px solid #e5e7eb;
}

.info-header {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 12px;
}

.info-icon {
  color: #0f65b0;
  font-size: 14px;
}

.info-label {
  font-size: 12px;
  font-weight: 600;
  color: #374151;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.resident-name {
  color: #1e293b;
  font-weight: 500;
  font-size: 14px;
  display: block;
  padding: 8px 0;
}

/* Users List */
.users-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
  max-height: 120px;
  overflow-y: auto;
}

.user-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  background: white;
  border-radius: 8px;
  border: 1px solid #e5e7eb;
  transition: all 0.2s ease;
}

.user-item:hover {
  border-color: #0f65b0;
  background: #f0f9ff;
}

.user-icon {
  color: #64748b;
  font-size: 12px;
  width: 16px;
  text-align: center;
}

.user-name {
  color: #374151;
  font-size: 13px;
  font-weight: 500;
}

/* Card Footer */
.card-footer {
  margin-top: auto;
  padding-top: 16px;
  border-top: 1px solid #e5e7eb;
}

.action-buttons {
  display: flex;
  gap: 8px;
  align-items: center;
  justify-content: flex-end;
}

/* Button Styles */
.btn-access-modern {
  background: linear-gradient(135deg, #4e9130 0%, #1e884d 100%) !important;
  color: white !important;
  border: none !important;
  border-radius: 10px !important;
  padding: 10px 16px !important;
  font-weight: 600 !important;
  font-size: 13px !important;
  text-transform: none !important;
  box-shadow: 0 3px 12px rgba(78, 145, 48, 0.25) !important;
  transition: all 0.3s ease !important;
}

.btn-access-modern:hover {
  transform: translateY(-2px) !important;
  box-shadow: 0 6px 20px rgba(78, 145, 48, 0.35) !important;
}

.btn-edit-modern {
  background: linear-gradient(135deg, #1d75be 0%, #155a8a 100%) !important;
  color: white !important;
  border: none !important;
  border-radius: 8px !important;
  font-weight: 600 !important;
  text-transform: none !important;
  font-size: 12px !important;
  box-shadow: 0 2px 8px rgba(29, 117, 190, 0.25) !important;
  transition: all 0.3s ease !important;
}

.btn-edit-modern:hover {
  transform: translateY(-1px) !important;
  box-shadow: 0 4px 12px rgba(29, 117, 190, 0.35) !important;
}

/* Scrollbar personalizada para lista de usuários */
.users-list::-webkit-scrollbar {
  width: 4px;
}

.users-list::-webkit-scrollbar-track {
  background: #f1f5f9;
  border-radius: 2px;
}

.users-list::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 2px;
}

.users-list::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}

/* Responsive Design */
@media (max-width: 1200px) {
  .folders-grid {
    grid-template-columns: repeat(auto-fill, minmax(340px, 1fr));
    gap: 20px;
  }
}

@media (max-width: 768px) {
  .folder-container {
    padding: 0 16px;
  }

  .folders-grid {
    grid-template-columns: 1fr;
    gap: 16px;
    margin: 20px 0;
  }

  .folder-card {
    padding: 20px;
  }

  .card-header {
    margin-bottom: 16px;
  }

  .card-icon {
    font-size: 28px;
    padding: 10px;
  }

  .card-title {
    font-size: 16px;
  }

  .action-buttons {
    flex-direction: column;
    gap: 12px;
  }

  .btn-access-modern,
  .btn-edit-modern {
    width: 100% !important;
    justify-content: center !important;
  }
}

@media (max-width: 480px) {
  .card-meta {
    gap: 6px;
  }

  .folder-type-badge,
  .folder-visibility-badge {
    font-size: 11px;
    padding: 3px 8px;
  }

  .resident-info,
  .users-info {
    padding: 12px;
    margin: 12px 0;
  }

  .info-label {
    font-size: 11px;
  }

  .user-item {
    padding: 6px 10px;
  }

  .user-name {
    font-size: 12px;
  }
}

/* Animation para quando os cards aparecem */
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.folder-card {
  animation: fadeInUp 0.5s ease forwards;
}

.folder-card:nth-child(1) {
  animation-delay: 0.1s;
}
.folder-card:nth-child(2) {
  animation-delay: 0.2s;
}
.folder-card:nth-child(3) {
  animation-delay: 0.3s;
}
.folder-card:nth-child(4) {
  animation-delay: 0.4s;
}
.folder-card:nth-child(5) {
  animation-delay: 0.5s;
}
.folder-card:nth-child(6) {
  animation-delay: 0.6s;
}
</style>